import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { detectLocale, isSupportedLocale } from '@/config/locales'
import { i18n } from '@/i18n'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: () => `/${detectLocale()}`,
  },
  {
    path: '/:locale',
    children: [
      { path: '', name: 'Index', component: () => import('@/views/Index.vue'), meta: { transitionKey: 1 } },
      { path: 'about', name: 'About', component: () => import('@/views/About.vue'), meta: { transitionKey: 2 } },
      { path: 'products', name: 'Products', component: () => import('@/views/Products.vue'), meta: { transitionKey: 3 } },
      {
        path: 'products/:category',
        name: 'ProductsCategory',
        component: () => import('@/views/Products.vue'),
        meta: { transitionKey: 33 },
      },
      {
        path: 'products/:category/:manufacture',
        name: 'ProductsCategoryManufacture',
        component: () => import('@/views/Products.vue'),
        meta: { transitionKey: 34 },
      },
      {
        path: 'products/:category/:manufacture/:name/:id',
        name: 'Product',
        component: () => import('@/views/Product.vue'),
        meta: { transitionKey: 35 },
      },
      { path: 'news', name: 'News', component: () => import('@/views/News.vue'), meta: { transitionKey: 7 } },
      {
        path: 'news/:id',
        name: 'NewsCard',
        component: () => import('@/views/NewsCard.vue'),
        meta: { transitionKey: 8 },
      },
      {
        path: 'check-code',
        name: 'CheckCode',
        component: () => import('@/views/CheckCode.vue'),
        meta: { transitionKey: 9 },
      },
      { path: 'contact', name: 'Contact', component: () => import('@/views/Contact.vue'), meta: { transitionKey: 10 } },
      {
        path: 'information',
        name: 'Information',
        component: () => import('@/views/Information.vue'),
        meta: { transitionKey: 11 },
      },
      {
        path: 'terms-and-conditions',
        name: 'TermsAndConditions',
        component: () => import('@/views/TermsAndConditions.vue'),
        meta: { transitionKey: 12 },
      },
      {
        path: 'delivery',
        name: 'Delivery',
        component: () => import('@/views/Delivery.vue'),
        meta: { transitionKey: 13 },
      },
      { path: 'privacy', name: 'Privacy', component: () => import('@/views/Privacy.vue'), meta: { transitionKey: 14 } },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: () => `/${detectLocale()}`,
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach((to) => {
  const locale = to.params.locale

  if (!isSupportedLocale(locale)) {
    return {
      ...to,
      params: { ...to.params, locale: detectLocale() },
      replace: true,
    }
  }

  i18n.global.locale.value = locale
  document.documentElement.lang = locale
  return true
})

export default router
